import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideSectionLabel,
  GuideBlockList,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const RecognizingEmotionalPatternsSection = ({ heading, accentIndex = 2, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="recognizing-emotional-patterns"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>Our emotions rarely appear randomly. They often follow familiar patterns.</GuideLead>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="stress" title="Before important meetings" description="Feeling anxious" />
      <GuideCard iconKey="communication" title="During difficult conversations" description="Becoming frustrated" />
      <GuideCard iconKey="energy" title="Late at night" description="Feeling lonely" />
      <GuideCard iconKey="awareness" title="After saying no" description="Feeling guilty" />
      <GuideCard iconKey="thinking" title="When receiving feedback" description="Becoming defensive" />
    </GuideCardGrid>
    <p className="guide-panel__p">
      These repeated experiences are emotional patterns. Recognizing them helps you prepare instead of
      being surprised.
    </p>
    <GuideSectionLabel>Ask yourself</GuideSectionLabel>
    <GuideBlockList
      items={[
        "What situations create stress for me?",
        "Which emotions appear most often?",
        "In which situations does the replay stop?",
        "What usually happens before I become upset?",
      ]}
    />
    <GuideCallout variant="amber">
      Keeping a thought record for a few weeks often reveals patterns you never noticed before.
      Patterns are powerful because once you recognize them, you can begin changing them.
    </GuideCallout>
  </GuidePanel>
);

export default RecognizingEmotionalPatternsSection;
